var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import MenuReturn from '../../components/console-common/menu-return.vue';
import IndicatorOverview from '../../components/ins-claim/claim-indicators.vue';
import GraphLine from '../../components/ins-claim/graph-line.vue';
import GraphBar from '../../components/ins-claim/graph-bar.vue';
import ClaimTable from '../../components/ins-claim/claim-table.vue';
import { chartLine } from './chart-config';
import { transBarOptions, transChartLineData, formDefaultSearchDate, } from './trans-data-util';
import { exportData } from './export-file';
import * as CLAIM_API from './claim-api';
import * as TIPS from './const-tips';
export default Vue.extend({
    props: {
        searchParam: {
            type: Object,
            default: null,
        },
    },
    components: {
        'el-menu-return': MenuReturn,
        'el-indicator-overview': IndicatorOverview,
        'chart-line': GraphLine,
        'chart-bar': GraphBar,
        'claim-table': ClaimTable,
    },
    computed: __assign({}, mapState('vinsurance', ['rentCompanyList', 'insCompanyList'])),
    data: function () {
        return {
            insCaseOptions: chartLine,
            searchDefaultParam: {},
            localParams: {},
            insCaseSum: '',
            insCaseAverage: '',
            activeTrendTab: '',
            activeTopVTab: '',
            titleConfig: {
                backTitle: '返回数据看板',
                currentTitle: '出险情况',
                routerName: true,
                name: 'claimBoard',
            },
            trendTabs: [
                {
                    label: '车型',
                    name: 'carModel',
                },
                {
                    label: '保司',
                    name: 'insCompany',
                },
                {
                    label: '地区',
                    name: 'cityArea',
                },
            ],
            topVehicalTabs: [
                {
                    label: '全部',
                    name: 'all',
                },
                {
                    label: '出险1次',
                    name: 'claimOnce',
                },
                {
                    label: '出险2次',
                    name: 'claimTwice',
                },
                {
                    label: '出险3次以上',
                    name: 'claimCrazy',
                },
            ],
            chartBarOptions: null,
            caseRankData: null,
            indicators: [
                {
                    span: 4,
                    label: '总出险次数',
                    value: '--',
                    type: 'line',
                    custFont: false,
                    tips: TIPS.TipHomeClaimTotalClaim,
                },
                {
                    span: 4,
                    label: '满期出险率',
                    value: '--%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeClaimExpiredRate,
                },
                {
                    span: 4,
                    label: '伤亡总数',
                    value: '--',
                    type: 'bar',
                    custFont: false,
                    tips: TIPS.TipHomeClaimTotalInjured,
                },
                {
                    span: 4,
                    label: '人伤出险占比',
                    value: '--%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeClaimInjuredRate,
                },
            ],
            tipsGraph: TIPS.TipSubClaimTrend,
            tipsRank: TIPS.TipsSubClaimRank,
            trendTableConfig: [
                {
                    label: '日期',
                    prop: 'date',
                    width: '260px',
                    // sortable: 'custom',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '出险次数',
                    // sortable: 'custom',
                    prop: 'caseCount',
                },
            ],
            vTableConfig: [
                {
                    label: '租赁公司',
                    prop: 'rentalCompanyName',
                    tooltip: true,
                    width: '280px',
                },
                {
                    label: '出险次数',
                    prop: 'caseCount',
                    tooltip: true,
                    width: '100px',
                },
                {
                    label: '车牌号',
                    prop: 'plateNo',
                    tooltip: true,
                    width: '120px',
                },
                {
                    label: '车架号',
                    prop: 'frameNo',
                    tooltip: true,
                },
            ],
        };
    },
    methods: {
        formParams: function () {
            return this.localParams;
        },
        setParams: function (params) {
            this.localParams = params;
        },
        initIndicatorDefault: function () {
            this.searchDefaultParam = this.formParams();
        },
        setupParams: function () {
            if (!this.insCompanyList || this.insCompanyList.length === 0) {
                this.$store.dispatch('vinsurance/GET_INS_COMPANYS'); // 获取保险公司选项
            }
            if (!this.rentCompanyList || this.rentCompanyList.length === 0) {
                this.$store.dispatch('vinsurance/GET_RENT_COMPANYS'); // 获取租赁公司选项
            }
            if (!this.searchParam) {
                this.setParams(formDefaultSearchDate());
            }
        },
        handleSearch: function (params) {
            this.setParams(params);
            this.onFreshPage();
        },
        // 车型/保司/地区 Tab
        handleTrendTab: function (tab, event) {
            this.activeTrendTab = tab.name;
            this.showCurrentBar();
        },
        showCurrentBar: function () {
            var dataset = [];
            if (this.activeTrendTab == this.trendTabs[0].name) {
                this.caseRankData.vehicleDimensionList.sort(function (a, b) {
                    return a.caseCount > b.caseCount
                        ? -1
                        : a.caseCount < b.caseCount
                            ? 1
                            : 0;
                });
                this.caseRankData.vehicleDimensionList
                    .slice(0, 10)
                    .forEach(function (item, index) {
                    dataset.push({
                        category: item.vehicleName || '--',
                        value: item.caseCount,
                    });
                });
            }
            else if (this.activeTrendTab === this.trendTabs[1].name) {
                this.caseRankData.insCompanyDimensionList.sort(function (a, b) {
                    return a.caseCount > b.caseCount
                        ? -1
                        : a.caseCount < b.caseCount
                            ? 1
                            : 0;
                });
                this.caseRankData.insCompanyDimensionList
                    .slice(0, 10)
                    .forEach(function (item, index) {
                    dataset.push({
                        category: item.insCompanyName || item.insCompanyCode,
                        value: item.caseCount,
                    });
                });
            }
            else {
                this.caseRankData.areaDimensionList.sort(function (a, b) {
                    return a.caseCount > b.caseCount
                        ? -1
                        : a.caseCount < b.caseCount
                            ? 1
                            : 0;
                });
                this.caseRankData.areaDimensionList.slice(0, 10).forEach(function (item) {
                    dataset.push({
                        category: item.inscityName,
                        value: item.caseCount,
                    });
                });
            }
            this.chartBarOptions = transBarOptions(dataset);
        },
        // 出险次数Tab
        handleTopVTab: function (tab, event) {
            this.activeTopVTab = tab.name;
            this.searchVehicleTable(1);
        },
        // 刷新整个页面
        onFreshPage: function () {
            var params = this.formParams();
            var ovParams = __assign({}, params, { overviewType: CLAIM_API.OVER_VIEW_CASE });
            this.loadOverview(ovParams);
            this.loadCaseTrend(params);
            this.searchTrendTable(1);
            this.loadCaseRank(params);
            this.searchVehicleTable(1);
        },
        loadOverview: function (params) {
            var _this = this;
            CLAIM_API.queryClaimOverview(params).then(function (res) {
                if (!res || !res.data || !res.data.riskOverview)
                    return;
                if (res.errorCode)
                    return;
                var _a = res.data.riskOverview, totalCaseCount = _a.totalCaseCount, expireCaseRate = _a.expireCaseRate, injurePersonNum = _a.injurePersonNum, injuryProportion = _a.injuryProportion;
                _this.indicators[0].value = totalCaseCount.toString();
                _this.indicators[1].value = expireCaseRate.toString() + '%';
                _this.indicators[2].value = injurePersonNum.toString();
                _this.indicators[3].value = injuryProportion.toString() + '%';
            });
        },
        searchTrendTable: function (pageNo) {
            var _this = this;
            var pageInfo = {
                page: pageNo,
                pageSize: CLAIM_API.PAGE_SIZE,
            };
            var params = __assign({}, this.formParams(), { pageInfo: pageInfo });
            CLAIM_API.queryCaseTrend(params).then(function (res) {
                if (!res || !res.data)
                    return;
                if (res.errorCode)
                    return;
                var pageInfo = {
                    pageNo: pageNo,
                    pageSize: CLAIM_API.PAGE_SIZE,
                    totalItemCount: res.data.totalCount,
                };
                _this.$refs.trendTable.fillTableData(res.data.riskTrendList, pageInfo);
            });
        },
        loadCaseTrend: function (params) {
            var _this = this;
            CLAIM_API.queryCaseTrend(params).then(function (res) {
                if (!res || !res.data)
                    return;
                if (res.errorCode)
                    return;
                _this.insCaseSum = res.data.totalCaseCount;
                _this.insCaseAverage = res.data.average;
                _this.insCaseOptions.data = transChartLineData(res.data.riskTrendList, 'caseCount');
                return res.data;
            });
        },
        // 2.2 出险趋势排名
        loadCaseRank: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$request({
                                url: '/proxy/insClaim/statistics/riskRanking',
                                method: 'post',
                                data: params,
                            }).then(function (res) {
                                if (!res)
                                    return;
                                if (res.errorCode)
                                    return;
                                _this.caseRankData = res.data;
                                if (!_this.chartBarOptions) {
                                    _this.showCurrentBar();
                                }
                                return res;
                            })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        // 2.3高频出险车辆信息
        searchVehicleTable: function (pageNo) {
            var _this = this;
            var pageInfo = {
                page: pageNo,
                pageSize: CLAIM_API.PAGE_SIZE,
            };
            var params = __assign({}, this.formParams(), { pageInfo: pageInfo, typeName: this.activeTopVTab });
            return this.$request({
                url: '/proxy/insClaim/statistics/frequentVehicle',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res || !res.data)
                    return;
                if (res.errorCode)
                    return;
                var dataset = [];
                var itemCounts = 0;
                if (_this.activeTopVTab === _this.topVehicalTabs[0].name) {
                    dataset = res.data.caseCountAllList;
                    itemCounts = res.data.totalCount;
                }
                else if (_this.activeTopVTab === _this.topVehicalTabs[1].name) {
                    dataset = res.data.caseCountOneList;
                    itemCounts = res.data.totalCountOne;
                }
                else if (_this.activeTopVTab === _this.topVehicalTabs[2].name) {
                    dataset = res.data.caseCountTwoList;
                    itemCounts = res.data.totalCountTwo;
                }
                else {
                    dataset = res.data.caseCountThreeList;
                    itemCounts = res.data.totalCountThree;
                }
                var pageInfo = {
                    pageNo: pageNo,
                    pageSize: CLAIM_API.PAGE_SIZE,
                    totalItemCount: itemCounts,
                };
                _this.$refs.vehicalTable.fillTableData(dataset, pageInfo);
            });
        },
        // 下载
        exportFile: function () {
            var params = this.formParams();
            exportData(params);
        },
    },
    mounted: function () {
        this.setupParams();
        if (this.searchParam) {
            this.setParams(this.searchParam);
        }
        this.initIndicatorDefault();
        this.activeTrendTab = this.trendTabs[0].name;
        this.activeTopVTab = this.topVehicalTabs[0].name;
        this.onFreshPage();
    },
});
